// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__PCjBU","label":"CategoryService_label__3Srjd","location":"CategoryService_location__3x_rA"};